/**
 * Leitura e validação das variáveis de ambiente do frontend.
 * Só variáveis públicas (prefixo VITE_). Segredos NUNCA aqui.
 */

const url = import.meta.env.VITE_SUPABASE_URL?.trim() ?? ''
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() ?? ''

export const env = {
  supabaseUrl: url,
  supabaseAnonKey: anonKey,
  appUrl: import.meta.env.VITE_APP_URL?.trim() || window.location.origin,
  inviteWorkerUrl: import.meta.env.VITE_INVITE_WORKER_URL?.trim() || '',
}

/** True quando as duas variáveis essenciais do Supabase estão presentes. */
export const isSupabaseConfigured = Boolean(url && anonKey && url.startsWith('http'))

export const missingEnvKeys: string[] = [
  !url && 'VITE_SUPABASE_URL',
  !anonKey && 'VITE_SUPABASE_ANON_KEY',
].filter(Boolean) as string[]
